// 定义需要管理的数据
export default {
  // 当前用户
  currentUser: {},
  // 后台获取的路由
  asyncRouters: [],
  // 全部资源列表
  allPermissionList: {},
  // 用户基本信息
  userBaseInfo: {},
  // 角色列表
  roleList: [],
  // 订单详情数据
  orderDetailInfo: {},
  // 系统角色列表
  sysRoleList: [],
  // 用户状态字典列表
  userStatusDicList: [],
  // 医生学位字典列表
  doctorDegreeDicList: [],
  // 医生职称字典列表
  doctorTitleDicList: [],
  // 医院等级字典列表
  hospitalDegreeDicList: [],
  // 医院列表
  hospitalNameIdList: [],
  // 销售公司列表
  companyNameIdList: [],
  // 管理员注册当前步骤
  registerStep: 0,
  // 管理员注册的用户信息
  registerUserInfo: {},
  // 积分状态字典列表
  pointStatusList: [],
  // 积分操作类型字典列表
  pointHandleTypeList: [],
  // 医院状态字典表信息
  hospitalStatusDicList: [],
  // 提现状态字典表信息
  withdrawStatusDicList: [],
  // 正在审核的提现id
  auditWithdrawId: '',
  // 医生状态字典表信息
  doctorStatusDicList: [],
  // 订单状态字典表信息
  orderStatusDicList: [],
  // 订单病理类型字典表信息
  orderPathologyTypeDicList: [],
  // 食道筛订单状态字典表信息
  esophagusStatusDicList: [],
  // 食道筛订单来源字典表信息
  esophagusFromDicList: [],
  // 食道筛产品状态字典表信息
  epsSNStatusDicList: [],
  // 获取实验室名称，ID 列表
  laboratoryIdNameIdList: [],
  // 获取快递付款方式
  expressPayMethodDicList: [],
  // 获取快递单位
  expressListDicList: [],
  // 收货方式
  receivingTypeListDicList: [],
  // 添加怡早学订单详情记录类型字典表
  recordTypeList: [],
  // 添加代理商列表，用于下拉查询
  agentList: [],
  // 微信公众号菜单列表
  wechatMenuList: []
}



// WEBPACK FOOTER //
// ./src/store/modules/states.js